import {BaseWrapper} from '../../framework/parameters/BaseWrapper';
import {BasicCriteria} from '../../framework/parameters/BasicCriteria';
import {BasicScenario} from '../../framework/parameters/BasicScenario';
import {Language} from '../message/Language';

export class LanguageWrapper extends BaseWrapper<Language, BasicCriteria, BasicScenario>  {}

